import { render } from "./Reussi.vue?vue&type=template&id=6c12512e"
import script from "./Reussi.vue?vue&type=script&lang=js"
export * from "./Reussi.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__